const FndUserRoleFields = [
    {
        name: '姓名',
        code: 'userName',
        column: true,
        sortable:false,
        defaultFilter: true
    },
    {
        name: '账号',
        code: 'userAccount',
        column: true,
        sortable:false,
        defaultFilter: true
    },
    {
        name: '邮箱',
        code: 'userEmail',
        align: 'center',
        sortable:false,
        defaultFilter: true
    },
    {
        name: '手机号',
        code: 'userPhone',
        sortable:false,
        align: 'center',
        defaultFilter: true
    }
]
export default FndUserRoleFields;